import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMcUnitAllQuickInfo extends Layout {
    buttonButton1: Button;
    labelError: Label;
    panelUnit: Panel;
    sourceMcUnitAll: DataSource;
    textboxAddress: Textbox;
    textboxControlID: Textbox;
    textboxDescription: Textbox;
    textboxID: Textbox;
}
